import { render } from "./DataRequirementRequest.vue?vue&type=template&id=15dfc2e9&scoped=true"
import script from "./DataRequirementRequest.vue?vue&type=script&lang=js"
export * from "./DataRequirementRequest.vue?vue&type=script&lang=js"

import "./DataRequirementRequest.vue?vue&type=style&index=0&id=15dfc2e9&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dfc2e9"]])

export default __exports__